import React from 'react';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-600 leading-relaxed">{children}</div>
  </div>
);

const ReturnPolicyPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Return & Refund Policy</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: August 2026</p>
      <div className="bg-white rounded-xl shadow p-8 space-y-6">
        <Section title="1. Return Eligibility">
          <p>Returns are accepted within 7 days of delivery for items that are damaged, defective, or not as described. Items must be unused, unwashed, and in original packaging with tags intact.</p>
        </Section>
        <Section title="2. Non-Returnable Items">
          <p>The following cannot be returned: items without original tags, used or washed items, sale/discounted items (unless defective), and innerwear or accessories for hygiene reasons.</p>
        </Section>
        <Section title="3. How to Initiate a Return">
          <p>Email us at <span className="text-[#DAA520]">sastadealpvt@gmail.com</span> with your order number, photos of the item, and reason for return. Our team will respond within 2 business days.</p>
        </Section>
        <Section title="4. Return Shipping">
          <p>For defective or incorrect items, we will arrange a pickup at no cost. For other eligible returns, the customer is responsible for return shipping charges.</p>
        </Section>
        <Section title="5. Refund After Return">
          <p>Once the returned item is received and verified, refunds are processed within 5–7 business days to your original payment method or as a bank transfer for COD orders.</p>
        </Section>
      </div>
    </div>
  </div>
);

export default ReturnPolicyPage;
